import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { fetchCategories } from '../shared/redtailQueryHelpers'

export default function useCategoryOptions (clientId, categoryIds, enabled = true) {
  const { data: all = [] } = useQuery({
    queryKey: ['redtail-categories', clientId],
    queryFn: () => fetchCategories(clientId),
    staleTime: 5 * 60 * 1000,
    enabled: !!clientId && enabled
  })

  return useMemo(() => {
    if (!categoryIds?.length) return all
    return all.filter(c => categoryIds.includes(c.value))
  }, [all, categoryIds])
}
